import React from 'react'
import './Footer.css'

export const Footer = () => {
  return (
    <div id="footer">
        <a href="#home">Home</a>
        <a href="#about-saveit">About SaveIT</a>
        <a href="#contact-me">Contact Me</a>
        <a href="#how-to-use">How to use?</a>
        <center><p id="copyright">Copyright &#169; 2022 | SaveIT</p></center>
    </div>
  )
}
